module.exports = __webpack_public_path__ + "img/introducePage_show_two.9bbeaddc.jpg";